import React from "react";
import { useEffect, useContext, useRef } from "react";
import PropTypes from 'prop-types';
import { OrgContext } from "../context/OrgContext";

/**
 * HOC to sync Drayage enable/disable state across tabs using BroadcastChannel
 * When Drayage is disabled, redirects to dashboard
 * When Drayage is enabled, updates orgSettings to re-render menu
 * Ignores messages from the same tab that sent them
 */
export const withDrayageSync = (WrappedComponent) => {
  return (props) => {
    const { history } = props;
    const { setOrgSettings } = useContext(OrgContext);
    const setOrgSettingsRef = useRef(setOrgSettings);

    // Keep ref in sync without triggering re-renders
    useEffect(() => {
      setOrgSettingsRef.current = setOrgSettings;
    }, [setOrgSettings]);

    useEffect(() => {
      let channel;
      try {
        channel = new BroadcastChannel('drayage_disable_channel');
        channel.onmessage = (event) => {
          const { senderId } = event.data || {};

          // Ignore messages from this tab (the sender)
          if (senderId && sessionStorage.getItem('drayage_setting_sender_id') === senderId) {
            sessionStorage.removeItem('drayage_setting_sender_id');
            return;
          }

          if (event.data?.action === 'redirect_to_dashboard') {
            // Drayage disabled - update orgSettings and redirect to dashboard
            setOrgSettingsRef.current?.((prev) => ({ ...prev, drayage_enabled: 'false' }));
            history?.push('/dashboard');
          } else if (event.data?.action === 'drayage_enabled' && event.data?.drayageEnabled) {
            // Drayage enabled - update orgSettings to re-render menu
            setOrgSettingsRef.current?.((prev) => ({ ...prev, drayage_enabled: event.data.drayageEnabled }));
          }
        };
      } catch (e) {}

      return () => {
        try { channel?.close(); } catch (e) {}
      };
    }, [history]);

    return <WrappedComponent {...props} />;
  };
};

withDrayageSync.propTypes = {
  history: PropTypes.object,
};
